export default __webpack_public_path__ + "static/media/bg_header.cbe67610.png";